import React, { useState } from 'react';
import { Logo } from './Logo';
interface LoginPageProps {
  onLogin: (email: string, password: string) => boolean;
}
export const LoginPage: React.FC<LoginPageProps> = ({
  onLogin
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    const success = onLogin(email, password);
    if (!success) {
      setError('Invalid email or password');
    }
  };
  return <div className="flex flex-col items-center justify-center min-h-screen bg-[#0a0a0a] text-white p-4 font-mono" data-id="element-431">
      <div className="w-full max-w-md p-8 space-y-8 bg-[#121212] rounded-lg shadow-lg" data-id="element-432">
        <div className="flex flex-col items-center space-y-4" data-id="element-433">
          <Logo data-id="element-434" />
          <h1 className="text-3xl mt-6" data-id="element-435">The Bridge</h1>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit} data-id="element-436">
          {error && <div className="bg-red-900/50 border border-red-800 text-white px-4 py-3 rounded relative" role="alert" data-id="element-437">
              <span className="block sm:inline" data-id="element-438">{error}</span>
            </div>}
          <div className="space-y-4" data-id="element-439">
            <div data-id="element-440">
              <label htmlFor="email" className="block text-sm text-gray-300" data-id="element-441">
                Email
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required className="mt-1 block w-full px-3 py-2 bg-[#1a1a1a] border border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" value={email} onChange={e => setEmail(e.target.value)} data-id="element-442" />
            </div>
            <div data-id="element-443">
              <label htmlFor="password" className="block text-sm text-gray-300" data-id="element-444">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="current-password" required className="mt-1 block w-full px-3 py-2 bg-[#1a1a1a] border border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" value={password} onChange={e => setPassword(e.target.value)} data-id="element-445" />
            </div>
          </div>
          <div data-id="element-446">
            <button type="submit" className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-447">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>;
};